const RICOS_VERSION = "10.130.3";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
